export const getGreeting = () => {
  const currentHour = new Date().getHours();

  if (currentHour < 12) return "Good morning";
  if (currentHour < 18) return "Good afternoon";
  return "Good evening";
};

export const getTimeSeries: () => string[] = () => {
  const times = [];

  for (let h = 0; h < 24; h++) {
    for (let m = 0; m < 60; m += 30) {
      const hour = h.toString().padStart(2, "0");
      const minute = m.toString().padStart(2, "0");
      times.push(`${hour}:${minute}`);
    }
  }

  times.push("24:00");
  return times;
};

export const DEFAULT_START_TIME = "09:00";
export const DEFAULT_END_TIME = "17:00";

export const getShortName = (
  name?: string,
  first_name?: string,
  last_name?: string,
) => {
  if (name) return name; // use full name if available
  if (first_name || last_name) {
    const firstInitial = first_name?.[0]?.toUpperCase() || "";
    const lastInitial = last_name?.[0]?.toUpperCase() || "";
    return `${firstInitial}${lastInitial}`;
  }
  return "";
};

export const sleep = (ms: number) =>
  new Promise((resolve) => setTimeout(resolve, ms));

export const applyThemeBackground = () => {
  const isHome =
    window.location.pathname === "/" || window.location.pathname === "";
  const isSitterApplication =
    window.location.pathname === "/sitter/application";

  if (isHome) {
    const isDark = document.documentElement.classList.contains("dark");
    const img = new Image();
    img.src = isDark
      ? "/media/images/bg-dark.png"
      : "/media/images/bg-light.png";
    img.onload = () => {
      document.body.style.background = `url(${img.src}) no-repeat 80% center / cover`;
    };
  } else if (isSitterApplication) {
    const isDark = document.documentElement.classList.contains("dark");
    const img = new Image();
    img.src = isDark
      ? "/media/images/bg-sitter-dark.png"
      : "/media/images/bg-sitter-light.png";
    img.onload = () => {
      document.body.style.background = `url(${img.src}) no-repeat 80% center / cover`;
    };
  } else {
    document.body.style.background = "";
  }
};
